module.exports = __webpack_public_path__ + "img/title-shiba.d0c4a30f.png";